import request from '@/utils/request-v2'

// ─── Games ────────────────────────────────────────────────────────────────────

export function getGames(query) {
  return request({
    url: '/teacher/outing/games?' + new URLSearchParams(query).toString(),
    method: 'get'
  })
}

export function getGame(gameId) {
  return request({
    url: `/teacher/outing/games/${gameId}`,
    method: 'get'
  })
}

export function createGame(data) {
  return request({
    url: '/teacher/outing/games',
    method: 'post',
    data
  })
}

export function updateGame(gameId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}`,
    method: 'put',
    data
  })
}

export function deleteGame(gameId) {
  return request({
    url: `/teacher/outing/games/${gameId}`,
    method: 'delete'
  })
}

// ─── Game Control ─────────────────────────────────────────────────────────────

export function startGame(gameId) {
  return request({
    url: `/teacher/outing/games/${gameId}/start`,
    method: 'post'
  })
}

export function endGame(gameId) {
  return request({
    url: `/teacher/outing/games/${gameId}/end`,
    method: 'post'
  })
}

// ─── Teams ────────────────────────────────────────────────────────────────────

export function getTeams(gameId) {
  return request({
    url: `/teacher/outing/games/${gameId}/teams`,
    method: 'get'
  })
}

export function getTeamsRanking(gameId) {
  return request({
    url: `/teacher/outing/games/${gameId}/teams-ranking`,
    method: 'get'
  })
}

export function createTeam(gameId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/teams`,
    method: 'post',
    data
  })
}

export function updateTeam(gameId, teamId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/teams/${teamId}`,
    method: 'put',
    data
  })
}

export function deleteTeam(gameId, teamId) {
  return request({
    url: `/teacher/outing/games/${gameId}/teams/${teamId}`,
    method: 'delete'
  })
}

// ─── Stages ───────────────────────────────────────────────────────────────────

export function getStages(gameId) {
  return request({
    url: `/teacher/outing/games/${gameId}/stages`,
    method: 'get'
  })
}

export function createStage(gameId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/stages`,
    method: 'post',
    data
  })
}

export function updateStage(gameId, stageId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/stages/${stageId}`,
    method: 'put',
    data
  })
}

export function deleteStage(gameId, stageId) {
  return request({
    url: `/teacher/outing/games/${gameId}/stages/${stageId}`,
    method: 'delete'
  })
}

// ─── Missions ─────────────────────────────────────────────────────────────────

export function getMissions(gameId) {
  return request({
    url: `/teacher/outing/games/${gameId}/missions`,
    method: 'get'
  })
}

export function createMission(gameId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/missions`,
    method: 'post',
    data
  })
}

export function updateMission(gameId, missionId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/missions/${missionId}`,
    method: 'put',
    data
  })
}

export function deleteMission(gameId, missionId) {
  return request({
    url: `/teacher/outing/games/${gameId}/missions/${missionId}`,
    method: 'delete'
  })
}

export function reorderStageMissions(gameId, stageId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/stages/${stageId}/missions/reorder`,
    method: 'put',
    data
  })
}

// ─── Questions ────────────────────────────────────────────────────────────────

export function listQuestions(gameId, missionId) {
  return request({
    url: `/teacher/outing/games/${gameId}/missions/${missionId}/questions`,
    method: 'get'
  })
}

export function createQuestion(gameId, missionId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/missions/${missionId}/questions`,
    method: 'post',
    data
  })
}

export function updateQuestion(gameId, missionId, questionId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/missions/${missionId}/questions/${questionId}`,
    method: 'put',
    data
  })
}

export function deleteQuestion(gameId, missionId, questionId) {
  return request({
    url: `/teacher/outing/games/${gameId}/missions/${missionId}/questions/${questionId}`,
    method: 'delete'
  })
}

// ─── Photo Mission Review ─────────────────────────────────────────────────────

export function listPhotoSubmissions(gameId) {
  return request({
    url: `/teacher/outing/games/${gameId}/photo-submissions`,
    method: 'get'
  })
}

export function reviewPhotoMission(gameId, teamMissionId, data) {
  return request({
    url: `/teacher/outing/games/${gameId}/photo-submissions/${teamMissionId}/review`,
    method: 'post',
    data
  })
}

// ─── Upload ───────────────────────────────────────────────────────────────────

export function uploadOutingFile({ target, classId, filename, file }) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: `/upload?target=${encodeURIComponent(
      target
    )}&filename=${encodeURIComponent(filename)}&classId=${encodeURIComponent(
      classId
    )}`,
    method: 'post',
    timeout: 0,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
